import {
  startOfMonth,
  subMonths,
  startOfYear,
  subYears,
  endOfYear,
  format,
  subDays,
  startOfDay,
  isEqual,
  max,
  endOfDay,
  getYear,
  isBefore,
  formatISO,
} from 'date-fns';

export const useDates = () => {
  function formatToIsoString(date: Date) {
    return formatISO(date, { format: 'extended' });
  }

  function isSameDate(firstDate: Date, secondDate: Date) {
    return isEqual(startOfDay(firstDate), startOfDay(secondDate));
  }
  function getEndOfDay(baseDate: Date): Date {
    return endOfDay(baseDate);
  }
  function getStartOfDay(baseDate: Date): Date {
    return startOfDay(baseDate);
  }
  function formatDateForTriggerTitle(date: Date) {
    return format(date, 'MMM dd, yyyy');
  }

  function getSubDaysFromBaseDate(baseDate: Date, subDaysAmount: number) {
    return subDays(baseDate, subDaysAmount);
  }

  function getSubMonthsFromBaseDate(baseDate: Date, subMonthsAmount: number) {
    return subMonths(baseDate, subMonthsAmount);
  }

  function getMaxDate(firstDate: Date, secondDate: Date) {
    return max([firstDate, secondDate]);
  }

  function formatWithSpecificScheme(date: Date, scheme: string) {
    return format(date, scheme);
  }

  function getToDateOfLastYear(baseDate: Date): Date {
    return endOfYear(subYears(baseDate, 1));
  }

  function isSmallerYearThanCurrentYear(baseDate: Date): boolean {
    const date = new Date(baseDate);
    const dateYear = getYear(date);
    const currentYear = getYear(new Date());
    return isBefore(dateYear, currentYear);
  }

  function getPeriodStartAndEndDates(baseDate: Date, presetType: string, tcTime: Date) {
    switch (presetType) {
      case 'last30Days':
        return { start: subDays(baseDate, 30), end: baseDate };

      case 'last60Days':
        return { start: subDays(baseDate, 60), end: baseDate };

      case 'last6Month':
        return { start: startOfMonth(subMonths(baseDate, 6)), end: baseDate };

      case 'currentYear':
        return { start: startOfYear(baseDate), end: baseDate };

      case 'lastYear':
        return { start: startOfYear(subYears(baseDate, 1)), end: endOfYear(subYears(baseDate, 1)) };

      default:
        return { start: new Date(tcTime), end: baseDate };
    }
  }

  return {
    getPeriodStartAndEndDates,
    formatDateForTriggerTitle,
    getSubDaysFromBaseDate,
    isSameDate,
    getSubMonthsFromBaseDate,
    getMaxDate,
    formatWithSpecificScheme,
    getEndOfDay,
    getToDateOfLastYear,
    getStartOfDay,
    startOfYear,
    subYears,
    isSmallerYearThanCurrentYear,
    isEqual,
    format,
    formatToIsoString,
  };
};
